<script lang="ts">
  export let list: {slug: string, title: string, direct?: boolean, href?: string}[] = [];
  export let item;
</script>

{#each list as { slug, title, direct, href }}
  {#if direct}
    <a class="block pl-2.5 py-2.5" {href} title={slug}>
      {title}
    </a>
  {:else}
    <a class="block pl-2.5 py-2.5" href="./{slug}" data-here={slug === item.slug} data-sveltekit-replacestate>
      {title}
    </a>
  {/if}
{/each}

<style>
  a[data-here=true] {
    --uno: border-true-gray-400 from-true-gray-900/60 to-true-gray-900/0;
  }

  a {
    --uno: no-underline;
    --uno: text-true-gray-100 visited:text-true-gray-300;

    --uno: border-l-solid border-2 border-true-gray-900 bg-gradient-to-r;
    --uno: hover:(border-true-gray-50 from-true-gray-800/70 to-true-gray-800/0);
    --uno: "active:!from-true-gray-800";
  }
</style>
